/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from 'react'
import { ErrorMessageProps } from './types'
import { FormValues } from 'donate/types'
import { ErrorMessage as FormikErrorMessage, useFormikContext } from 'formik'

export const ErrorMessage = ({ field }: ErrorMessageProps) => {
  const formik = useFormikContext<FormValues>()

  if (formik.errors[field] && formik.touched[field]) {
    return <FormikErrorMessage name={field} component="div" className="help-inline" />
  }

  if (formik.status && formik.status.customErrors && formik.status.customErrors[field]) {
    return <div className="help-inline">{formik.status.customErrors[field]}</div>
  }

  return null
}
